// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactBox__container","imageContainer":"ContactBox__imageContainer","title":"ContactBox__title"};